import Vue from "vue";
import firebase from "firebase";
import { firestorePlugin } from "vuefire";
import "./plugins/vuetify";
import "./plugins/vuse";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";
import { createI18n } from "./i18n/index";
import axios from "axios";
import VueVideoPlayer from "vue-video-player";
// require videojs style
import "video.js/dist/video-js.css";
//import { VueReCaptcha } from "vue-recaptcha-v3";
import VueAnalytics from "vue-analytics";

window.jQuery = require("jquery");
window.$ = window.jQuery;

Vue.config.productionTip = false;

const i18n = createI18n();

Vue.prototype.$http = axios;

Vue.use(firestorePlugin);
//Vue.use(VueReCaptcha, { siteKey: "6LeJE7wUAAAAACDcKCnawW3pkpUdQJ9taySgkqj8" });
Vue.use(
  VueVideoPlayer /* { options: global default options, events: global videojs events } */
);

// https://github.com/MatteoGabriele/vue-analytics
Vue.use(VueAnalytics, {
  id: "UA-153622901-1",
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === "production"
  },
  commands: {
    trackSimpleSignatureTryButton() {
      this.$ga.event({
        eventCategory: "SimpleSignature", // str
        eventAction: "click", // str
        eventLabel: "TryButton", // str
        eventValue: 0 // int
      });
    },
    trackVideoIdentificationTryButton() {
      this.$ga.event({
        eventCategory: "VideoIdentification", // str
        eventAction: "click", // str
        eventLabel: "TryButton", // str
        eventValue: 0 // int
      });
    },
    trackCertifiedNotificationTryButton() {
      this.$ga.event({
        eventCategory: "CertifiedNotification", // str
        eventAction: "click", // str
        eventLabel: "TryButton", // str
        eventValue: 0 // int
      });
    },
    trackVideoIdentificationCreateButton() {
      this.$ga.event({
        eventCategory: "VideoIdentification", // str
        eventAction: "click", // str
        eventLabel: "CreateButton", // str
        eventValue: 0 // int
      });
    }
  }
});

var firebaseConfig = {
  apiKey: "AIzaSyDfEYnEnZ81qcreqY4VyoIEFtsziW76eM4",
  authDomain: "securiti1-123.firebaseapp.com",
  databaseURL: "https://securiti1-123.firebaseio.com",
  projectId: "securiti1-123",
  storageBucket: "securiti1-123.appspot.com",
  messagingSenderId: "1048169686447",
  appId: "1:1048169686447:web:a29c2e445923f4a1",
  measurementId: "G-HFQD2D7PCL"
};

firebase.initializeApp(firebaseConfig);
Vue.prototype.$db = firebase.firestore();
// Para el componente de insertar OTP
Vue.prototype.$otp = "";
Vue.prototype.EventBus = new Vue();

// Vue.prototype.EventTrackingGA = (category, action, label, value) => {
//   this.$ga.event({
//     eventCategory: category, // str
//     eventAction: action, // str
//     eventLabel: label, // str
//     eventValue: value // int
//   });
// };

const { TimeStamp, GeoPoint } = firebase.firestore;
export { TimeStamp, GeoPoint };
// Vue.mixin({
//   created() {
//     console.log(++count);
//   },
//   destroyed() {
//     console.log(--count);
//   }
// });

new Vue({
  router,
  store,
  i18n,
  beforeCreate() {
    const domainUuid = "2w2w-3e3e3-3e3e3-cdcddcdcd";
    this.$store.commit("setDomainUuid", domainUuid);
    this.$store.commit("loading", false);

    // Add a request interceptor
    axios.interceptors.request.use(
      config => {
        // Do something before request is sent
        if (
          !config.url.includes("login") &&
          !config.url.includes("refresh") &&
          !config.url.includes("create/")
        ) {
          config.headers.Authorization = this.$store.getters.esignToken;
        } else if (config.url.includes("create/")) {
          config.headers.Authorization = this.$store.getters.token;
        } else if (config.url.includes("refresh")) {
          config.headers.Authorization = this.$store.getters.token;
        }

        config.headers.Pragma = "no-cache";
        config.headers.CacheControl = "no-cache";
        config.headers["Cache-Control"] = "no-cache";
        config.headers.Expires = -1;

        if (
          !config.url.includes("start") &&
          !config.url.includes("/detection/") &&
          !config.url.includes("/saveidentificationdata/") &&
          !config.url.includes("/identificationresult/")
        ) {
          this.$store.commit("loading", true);
        }
        return config;
      },
      error => {
        this.$store.commit("loading", false);
        return Promise.reject(error);
      }
    );
    // Add a response interceptor
    axios.interceptors.response.use(
      response => {
        this.$store.commit("loading", false);
        return response;
      },
      error => {
        if (error.response && error.response.status === 401) {
          // We need to refresh the token.
          return axios
            .get(process.env.ENDPOINT_PREFIX + "/refresh")
            .then(() => {
              this.$store.commit("loading", false);
              return axios(error.config);
            })
            .catch(errorRefresh => {
              this.$store.commit("loading", false);
              return Promise.reject(errorRefresh);
            });
        } else {
          this.$store.commit("loading", false);
          return Promise.reject(error);
        }
      }
    );
  },
  render: h => h(App)
}).$mount("#app");
